import { OperationProgressStatus } from "@/components/progress";
import { cn } from "@/lib/utils";
import { PropsWithChildren } from "react";

interface AsyncOperationProgressAbsoluteWrapperProps extends PropsWithChildren {
  className?: string;
  status: OperationProgressStatus;
}

/**
 * Wrapper component that positions AsyncOperationProgress absolutely within a DialogContent,
 * creating an overlay effect with backdrop blur. Use this when you want the progress indicator to
 * overlay the dialog content.
 */
export const AsyncOperationProgressAbsoluteWrapper = ({
  children,
  className,
  status,
}: AsyncOperationProgressAbsoluteWrapperProps) => {
  if (status === OperationProgressStatus.IDLE) {
    return null;
  }

  return (
    <>
      <div
        className={cn(
          "z-50 absolute inset-0 bg-black/50 backdrop-blur-sm flex flex-col justify-center items-center p-6 overflow-hidden",
          className,
        )}
      >
        <div className="w-full max-w-md rounded-lg bg-background shadow-xl p-6">
          {children}
        </div>
      </div>
    </>
  );
};
